<script>
import { Bar } from "vue-chartjs";
import { generateColorByString } from "@/services/chart-helper.js";

export default {
  name: "IkpMedParamsAverageMeasurementChart",
  extends: Bar,

  props: {
    items: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      options: {
        maintainAspectRatio: false,
        responsive: true,
        scales: {
          xAxes: [{}],
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                stepSize: 5,
              },
            },
          ],
        },
      },
    };
  },

  computed: {
    labels() {
      return [...new Set(this.items.map(item => item.date_without_time))];
    },

    dataset() {
      const data = new Map();
      this.items.forEach(item => {
        const val = { x: item.date_without_time, y: item.med_param_value };

        if (data.has(item.med_param_name)) {
          data.get(item.med_param_name).data.push(val);
        } else {
          const nameLen = item.med_param_name.length;
          data.set(item.med_param_name, {
            label: item.med_param_name,
            backgroundColor: generateColorByString(item.med_param_name + item.med_param_name.charCodeAt(nameLen - 1) + nameLen),
            data: [val],
            order: item.med_param_name === "Индекс результата" ? 1 : 2,
          });
        }
      });

      return Array.from(data.values());
    },
  },

  watch: {
    items() {
      this.render();
    },
  },

  async mounted() {
    this.render();
  },

  methods: {
    render() {
      this.renderChart(
        {
          labels: this.labels,
          datasets: this.dataset,
        },
        this.options,
      );
    },
  },
};
</script>
